/**
 * 职责：默认 SubAgentNode 纵向嵌套容器 widget（方案 A 已退场）。
 * 链路位置：宿主可通过 NodeRegistry.register('subagent', SubAgentBlock) 恢复旧行为。
 * 当前裁剪范围：纵向缩进；不含横向并列布局。
 * @deprecated 方案 A 主时间线不再渲染 SubAgentBlock；子 agent progress 折叠在 AgentToolBody。
 */
import { useChildren, useNodeTyped } from '../../core/hooks';
import { useNodeRegistry } from '../../core/context/SessionContext';
import { TimelineItem } from '../Timeline';

export interface SubAgentBlockProps {
  nodeId: string;
}

export function SubAgentBlock({ nodeId }: SubAgentBlockProps) {
  const node = useNodeTyped(nodeId, 'subagent');
  const childIds = useChildren(nodeId);
  const registry = useNodeRegistry();
  if (!node) return null;

  return (
    <div className="lax-subagent-block" data-status={node.status}>
      <div className="lax-subagent-block__header">SubAgent: {node.subagentId}</div>
      <div className="lax-subagent-block__children">
        {childIds.map((childId) => (
          <TimelineItem key={childId} nodeId={childId} registry={registry} />
        ))}
      </div>
    </div>
  );
}
